<template>
  <div class="help">
    <div class="help-title__main red large">您当前抖音推广权限未开启，如需开启，把右上角注册名称发给对接的商务人员进行功能开通</div>
    <div class="help-title__sub default">一、抖音电影票推广是什么？</div>
    <div>厦门守兔网络科技有限公司（下称“守兔平台”）推出抖音购票小程序【极光影票】，助力抖音达人合作伙伴进行电影票推广。通过直播或短视频挂载小程序，提供便捷的购票下单入口。平台按您的销售成交额支付佣金。</div>
    <div>抖音小程序体验：打开抖音APP，搜索“极光影票”：</div>
    <img class="help-img help-img__1" src="../../../assets/img/help/1.png" mode="scaleToFill" />
    <div class="help-title__sub default">二、项目推广优势？</div>
    <div>1.市场需求优势</div>
    <div>影视票房在蹭蹭往上涨，2023年中国票房突破500亿。且电影作为全民娱乐活动，具有广大的市场，特别节假日能够吸引大量的用户，会持续爆单。</div>
    <div>2.用户购票折扣优势</div>
    <div>小程序覆盖全国95%以上影院，用户通过极光影票小程序购买的价格比其他渠道能便宜5到30元。1-60分钟出票。</div>
    <div>3.免费对接推广</div>
    <div>平台不收取任何对接费用。灵活易推广，平台提供分销模式，您可以自己发展分销达人。</div>
    <div>3.售后服务</div>
    <div>我们提供强大的售后团队，几十个客服365天，8-23点在线，一站式解决消费者购票服务、售前和售后问题。</div>


    <div class="help-title__sub default">三、如何进行推广？</div>
    <div>1. 注册抖音账号+养号，准备千粉账号（电脑开播条件）</div>
    <div>2.	联系平台对接</div>
    <div>登录https://movie.pintoto.cn/注册成为推广者，并联系商务开通推广权限。</div>
    <div>平台支持两种角色挂载小程序：</div>
    <div>①直播挂载：在抖音直播页面上添加电影票小程序，按照指示设置完小程序后，添加准备好的直播素材就可以开始直播了。如果您不想真人出镜，可以使用特效道具来遮挡脸部。</div>
    <div>直播案例收益数据参考：</div>
    <img class="help-img help-img__2" src="../../../assets/img/help/2.png" mode="scaleToFill" />
    <div>假设平台按照6%佣金比例给您结算佣金，100万的销售额，您可以到手6万佣金。</div>
    <div>②短视频挂载：在抖音发布短视频时可挂载小程序，通过视频内容的介绍引导用户进入小程序购买、体验、互动等，视频一定要足够吸引人哦！</div>
    <div>短视频案例收益数据参考：</div>
    <img class="help-img help-img__2" src="../../../assets/img/help/3.png" mode="scaleToFill" />
    <div>极光影票目前已有上万名合作达人，诚邀您的加入！</div>
    <div class="help-title__tip red default">相关对接咨询，如何挂载短视频和获取直播链接路径请联系相应的商务人员确认！！</div>
  </div>
</template>

<script>
export default {
  name: "help",
};
</script>

<style scoped lang="less">
.help {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 30px 100px;
  overflow-y: auto;
  &::-webkit-scrollbar-track-piece {
      margin: 8px;
      border-radius: 4px
    }

    &::-webkit-scrollbar {
      width: 7px;
      height: 7px
    }

    &::-webkit-scrollbar-thumb {
      background: #eef0f8;
      border-radius: 4px
    }
  .red {
    color: #FF4F76;
  }

  .default {
    font-size: 16px;
  }

  .large {
    font-size: 18px;
  }

  &-img {
    border: 1px solid #f3f3f3;
    border-radius: 5px;

    &__1 {
      width: 370px;
      height: 277px;
      margin-top:12px;
    }
    &__2 {
      width:1300px;
      height: 343px;
      margin: 12px 0;
    }
    &__4 {
      width:300px;
      height: 370px;
      margin: 12px 0;
    }
  }

  &-title {
    &__main {
      margin-bottom: 30px;
    }

    &__tip {
      margin-top: 40px;
    }

    &__sub {
      margin: 30px 0 12px 0;
      font-weight: bold;
    }


  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/help.vue